import { useLayoutEffect, useRef, useState } from "react";

import { CoAppLightTooltip } from "../global/styled/global.styled";
import { RuleLibraryLongTextCell } from "./styled/rule-library.styled";

export type RuleDataGridLongTextCellProps = {
	value: string;
	hasBeforeEffect?: boolean;
	isTrashed?: boolean;
};

export default function RuleDataGridLongTextCell({
	value,
	hasBeforeEffect = false,
	isTrashed = false
}: RuleDataGridLongTextCellProps) {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const [localValue, setLocalValue] = useState(value);
	const ref = useRef<HTMLDivElement>(null);

	/**
	 * Allows us to clip the text shown in our description cells based on string length and window width.
	 * Note: This allows us to use multiline text until an ellipsis is needed to indicate overflow.
	 */
	const getSliceCount = () => {
		const windowWidth = window.innerWidth;
		if (windowWidth > 1800 && value.length > 75) {
			return 75;
		} else if (windowWidth > 1600 && windowWidth <= 1800 && value.length > 65) {
			return 65;
		} else if (windowWidth > 1400 && windowWidth <= 1600 && value.length > 40) {
			return 40;
		} else if (windowWidth > 1100 && windowWidth <= 1300 && value.length > 30) {
			return 30;
		} else {
			return null;
		}
	};

	const handleLayoutEffect = () => {
		const el = ref.current;
		if (!el) {
			return;
		}
		if (el.clientHeight < el.scrollHeight) {
			setIsOverflowing(true);
			const substringCount = getSliceCount();
			setLocalValue(substringCount ? value.substring(0, substringCount) : value);
		} else if (isOverflowing) {
			const substringCount = getSliceCount();
			setLocalValue(substringCount ? value.substring(0, substringCount) : value);
		} else {
			setLocalValue(value);
		}
	};

	useLayoutEffect(() => {
		handleLayoutEffect();
	}, [isOverflowing, window.innerWidth]);

	return (
		<div>
			{
				!isOverflowing ?
					<RuleLibraryLongTextCell
						ref={ref}
						before={hasBeforeEffect ? "true" : "false"}
						trashed={isTrashed ? "true" : "false"}
					>
						{value}
					</RuleLibraryLongTextCell>
					:
					<CoAppLightTooltip title={value}>
						<RuleLibraryLongTextCell
							ref={ref}
							overflowing={isOverflowing ? "true" : "false"}
							before={hasBeforeEffect ? "true" : "false"}
							trashed={isTrashed ? "true" : "false"}
						>
							{localValue}
						</RuleLibraryLongTextCell>
					</CoAppLightTooltip>
			}
		</div>
	);
}